<template>
  <div class="page">
    <div class="locations-white locations-generic">
      <section>
        <div class="locations-title">Busse Reservoir, Elk Grove Village</div>
        <!-- <strong>Season: April - October</strong> -->
        <br />
        <!-- <strong>Open Seven Days Per Week</strong>  -->
      </section>
      <section>
        <div>
          <!-- <strong>Open: Friday, May 12</strong> -->
        </div>
      </section>
      <section>
        <div>
        <!-- <strong>Open Seven Days Per Week</strong> -->
        <!-- <br><br> -->
        </div>
        <strong>Hours:</strong>
        Closed for the Season
        <br><br>
        <!-- Saturday and Sunday: 8:00 a.m. until last rental, 6:30 p.m.
        <br> -->
      </section>
      <section>
        <strong>Boat Rentals:</strong>
        Kayaks, Canoes, Row Boats 
        <!-- <span>(Note: due to unfavorable water conditions, Fishing Boats are temporarily unavailable)</span> -->
      </section>
      <section>
        <strong>For Sale:</strong>
        Drinks, Snacks, Ice Cream, and Bait
      </section>
      <!-- <section>
        <strong>Events: </strong>
        Temporarily unavailable
      </section> -->
      <section>
        <strong>Minimum age and Weight:</strong>
        3 years, 35 lbs. (may be higher depending on water and weather
        conditions)
      </section>
      <a
        class="btn-primary btn"
        href="https://www.google.com/maps/dir/?api=1&destination=42.024276,-88.014061"
      >
        <strong>Directions</strong>
      </a>
    </div>
    <div class="locations-green locations-generic">
      <call-button tel-number="224-415-6554" />
      <br />Higgins Rd., Elk Grove Village
      <br />
    </div>

    <Button class="scroll-button d-lg-none" @click="scrollToTop()">
      <i class="fas fa-arrow-down"></i>
    </Button>

    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11855.311186439538!2d-88.01560301346926!3d42.025426444662195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fafd45c08cbc1%3A0xdac230482a798632!2sBusse%20Lake%20Boating%20Center!5e0!3m2!1sen!2sus!4v1588721514470!5m2!1sen!2sus"
      width="600"
      height="450"
      frameborder="0"
      style="border:0;"
      allowfullscreen
      aria-hidden="false"
      tabindex="0"
    ></iframe>
  </div>
</template>

<script>
import CallButton from "../CallButton";

export default {
  name: "Busse",
  components: { CallButton },
  props: {
    msg: String,
  },
  methods: {
    scrollToTop() {
      var objDiv = document.getElementsByClassName("page")[0];
      objDiv.scrollTop = objDiv.scrollHeight;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.call-button {
  color: white;
}

span {
  color: red;
}

iframe {
  max-width: 90%;
}
.page {
  background-image: url("../../assets/busse.jpg");
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
.scroll-button {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
</style>
